import { render, staticRenderFns } from "./ResumeCard.vue?vue&type=template&id=0f798756"
import script from "./ResumeCard.vue?vue&type=script&lang=js"
export * from "./ResumeCard.vue?vue&type=script&lang=js"
import style0 from "./ResumeCard.vue?vue&type=style&index=0&id=0f798756&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports